import { useNavigate, useParams } from 'react-router-dom';
import Button from 'components/Button';
import Plus from 'components/icons/plus';
import useManageExternalAutomations from 'data/hooks/useManageExternalAutomations';
import { StyledCard } from '../styled';
import ExternalAutomationsList from './externalAutomationsList';
import { RightContent, SearchContainer } from './styled';
import { ADD_EDIT_EXTERNAL_AUTOMATION_DRAWER } from '../../../constants';

const ExternalAutomationsListPage = () => {
    const { agentId = '' } = useParams<{ agentId?: string }>();
    const navigate = useNavigate();
    const { create } = useManageExternalAutomations({
        agentId,
        modalId: ADD_EDIT_EXTERNAL_AUTOMATION_DRAWER,
    });

    return (
        <StyledCard>
            <SearchContainer>
                <RightContent>
                    <Button
                        variant="brand"
                        size="medium"
                        borderRadius="semi-rounded"
                        onClick={() => create({
                            onCompleted: (
                                externalAutomation: Record<string, unknown>,
                            ) => {
                                navigate(externalAutomation.id as string);
                            },
                        })}
                    >
                        <Plus className="rainbow-m-right_small" />
                        New
                    </Button>
                </RightContent>
            </SearchContainer>
            <ExternalAutomationsList />
        </StyledCard>
    );
};

export default ExternalAutomationsListPage;
